import AccountCircle from "@material-symbols/svg-400/outlined/account_circle.svg?react";
import Add from "@material-symbols/svg-400/outlined/add.svg?react";
import AddComment from "@material-symbols/svg-400/outlined/add_comment.svg?react";
import Archive from "@material-symbols/svg-400/outlined/archive.svg?react";
import ArrowBack from "@material-symbols/svg-400/outlined/arrow_back.svg?react";
import ArrowDownward from "@material-symbols/svg-400/outlined/arrow_downward.svg?react";
import ArrowDropDown from "@material-symbols/svg-400/outlined/arrow_drop_down.svg?react";
import ArrowDropUp from "@material-symbols/svg-400/outlined/arrow_drop_up.svg?react";
import ArrowForward from "@material-symbols/svg-400/outlined/arrow_forward.svg?react";
import ArrowLeft from "@material-symbols/svg-400/outlined/arrow_left.svg?react";
import ArrowRight from "@material-symbols/svg-400/outlined/arrow_right.svg?react";
import ArrowRightAlt from "@material-symbols/svg-400/outlined/arrow_right_alt.svg?react";
import ArrowUpward from "@material-symbols/svg-400/outlined/arrow_upward.svg?react";
import Article from "@material-symbols/svg-400/outlined/article.svg?react";
import ArticlePerson from "@material-symbols/svg-400/outlined/article_person.svg?react";
import Assignment from "@material-symbols/svg-400/outlined/assignment.svg?react";
import BackHand from "@material-symbols/svg-400/outlined/back_hand.svg?react";
import Backup from "@material-symbols/svg-400/outlined/backup.svg?react";
import BarChart from "@material-symbols/svg-400/outlined/bar_chart.svg?react";
import Bedtime from "@material-symbols/svg-400/outlined/bedtime.svg?react";
import Block from "@material-symbols/svg-400/outlined/block.svg?react";
import BlurOn from "@material-symbols/svg-400/outlined/blur_on.svg?react";
import Bolt from "@material-symbols/svg-400/outlined/bolt.svg?react";
import Cached from "@material-symbols/svg-400/outlined/cached.svg?react";
import Cake from "@material-symbols/svg-400/outlined/cake.svg?react";
import CalendarToday from "@material-symbols/svg-400/outlined/calendar_today.svg?react";
import Call from "@material-symbols/svg-400/outlined/call.svg?react";
import CallMade from "@material-symbols/svg-400/outlined/call_made.svg?react";
import CallMissed from "@material-symbols/svg-400/outlined/call_missed.svg?react";
import CallMissedOutgoing from "@material-symbols/svg-400/outlined/call_missed_outgoing.svg?react";
import CallReceived from "@material-symbols/svg-400/outlined/call_received.svg?react";
import Cancel from "@material-symbols/svg-400/outlined/cancel.svg?react";
import Celebration from "@material-symbols/svg-400/outlined/celebration.svg?react";
import Chat from "@material-symbols/svg-400/outlined/chat.svg?react";
import Check from "@material-symbols/svg-400/outlined/check.svg?react";
import CheckBox from "@material-symbols/svg-400/outlined/check_box.svg?react";
import CheckCircleFill from "@material-symbols/svg-400/outlined/check_circle-fill.svg?react";
import CheckCircle from "@material-symbols/svg-400/outlined/check_circle.svg?react";
import Checklist from "@material-symbols/svg-400/outlined/checklist.svg?react";
import ChevronLeft from "@material-symbols/svg-400/outlined/chevron_left.svg?react";
import ChevronRight from "@material-symbols/svg-400/outlined/chevron_right.svg?react";
import Close from "@material-symbols/svg-400/outlined/close.svg?react";
import Comment from "@material-symbols/svg-400/outlined/comment.svg?react";
import ContactSupportOutlined from "@material-symbols/svg-400/outlined/contact_support.svg?react";
import ContentCopy from "@material-symbols/svg-400/outlined/content_copy.svg?react";
import ContentPaste from "@material-symbols/svg-400/outlined/content_paste.svg?react";
import ContentPasteSearch from "@material-symbols/svg-400/outlined/content_paste_search.svg?react";
import Contract from "@material-symbols/svg-400/outlined/contract.svg?react";
import Cottage from "@material-symbols/svg-400/outlined/cottage.svg?react";
import Dangerous from "@material-symbols/svg-400/outlined/dangerous.svg?react";
import Delete from "@material-symbols/svg-400/outlined/delete.svg?react";
import Description from "@material-symbols/svg-400/outlined/description.svg?react";
import DirectionsCar from "@material-symbols/svg-400/outlined/directions_car.svg?react";
import DirectionsWalk from "@material-symbols/svg-400/outlined/directions_walk.svg?react";
import Diversity1 from "@material-symbols/svg-400/outlined/diversity_1.svg?react";
import DocumentScanner from "@material-symbols/svg-400/outlined/document_scanner.svg?react";
import Download from "@material-symbols/svg-400/outlined/download.svg?react";
import Draft from "@material-symbols/svg-400/outlined/draft.svg?react";
import Draw from "@material-symbols/svg-400/outlined/draw.svg?react";
import Edit from "@material-symbols/svg-400/outlined/edit.svg?react";
import Elderly from "@material-symbols/svg-400/outlined/elderly.svg?react";
import Error from "@material-symbols/svg-400/outlined/error.svg?react";
import Euro from "@material-symbols/svg-400/outlined/euro.svg?react";
import Event from "@material-symbols/svg-400/outlined/event.svg?react";
import EventAvailable from "@material-symbols/svg-400/outlined/event_available.svg?react";
import EventBusy from "@material-symbols/svg-400/outlined/event_busy.svg?react";
import FactCheck from "@material-symbols/svg-400/outlined/fact_check.svg?react";
import FavoriteFill from "@material-symbols/svg-400/outlined/favorite-fill.svg?react";
import Favorite from "@material-symbols/svg-400/outlined/favorite.svg?react";
import FileCopy from "@material-symbols/svg-400/outlined/file_copy.svg?react";
import FilterAlt from "@material-symbols/svg-400/outlined/filter_alt.svg?react";
import FindReplace from "@material-symbols/svg-400/outlined/find_replace.svg?react";
import Folder from "@material-symbols/svg-400/outlined/folder.svg?react";
import FolderOpen from "@material-symbols/svg-400/outlined/folder_open.svg?react";
import FolderShared from "@material-symbols/svg-400/outlined/folder_shared.svg?react";
import FollowTheSigns from "@material-symbols/svg-400/outlined/follow_the_signs.svg?react";
import Forest from "@material-symbols/svg-400/outlined/forest.svg?react";
import FormatBold from "@material-symbols/svg-400/outlined/format_bold.svg?react";
import FormatItalic from "@material-symbols/svg-400/outlined/format_italic.svg?react";
import FormatListBulleted from "@material-symbols/svg-400/outlined/format_list_bulleted.svg?react";
import FormatListNumbered from "@material-symbols/svg-400/outlined/format_list_numbered.svg?react";
import FormatStrikethrough from "@material-symbols/svg-400/outlined/format_strikethrough.svg?react";
import FormatUnderlined from "@material-symbols/svg-400/outlined/format_underlined.svg?react";
import Forum from "@material-symbols/svg-400/outlined/forum.svg?react";
import Group from "@material-symbols/svg-400/outlined/group.svg?react";
import Handshake from "@material-symbols/svg-400/outlined/handshake.svg?react";
import Home from "@material-symbols/svg-400/outlined/home.svg?react";
import HomeWork from "@material-symbols/svg-400/outlined/home_work.svg?react";
import HowToReg from "@material-symbols/svg-400/outlined/how_to_reg.svg?react";
import Info from "@material-symbols/svg-400/outlined/info.svg?react";
import Keyboard from "@material-symbols/svg-400/outlined/keyboard_alt.svg?react";
import Link from "@material-symbols/svg-400/outlined/link.svg?react";
import ListAlt from "@material-symbols/svg-400/outlined/list_alt.svg?react";
import LocationOff from "@material-symbols/svg-400/outlined/location_off.svg?react";
import LocationOn from "@material-symbols/svg-400/outlined/location_on.svg?react";
import LockOpen from "@material-symbols/svg-400/outlined/lock_open.svg?react";
import Mail from "@material-symbols/svg-400/outlined/mail.svg?react";
import Map from "@material-symbols/svg-400/outlined/map.svg?react";
import MarkChatUnread from "@material-symbols/svg-400/outlined/mark_chat_unread.svg?react";
import MedicalInformation from "@material-symbols/svg-400/outlined/medical_information.svg?react";
import Mic from "@material-symbols/svg-400/outlined/mic.svg?react";
import MonitorHeart from "@material-symbols/svg-400/outlined/monitor_heart.svg?react";
import MoreHoriz from "@material-symbols/svg-400/outlined/more_horiz.svg?react";
import MoreTime from "@material-symbols/svg-400/outlined/more_time.svg?react";
import News from "@material-symbols/svg-400/outlined/news.svg?react";
import NoPhotography from "@material-symbols/svg-400/outlined/no_photography.svg?react";
import NotListedLocation from "@material-symbols/svg-400/outlined/not_listed_location.svg?react";
import Notifications from "@material-symbols/svg-400/outlined/notifications.svg?react";
import NotificationsOff from "@material-symbols/svg-400/outlined/notifications_off.svg?react";
import OfflineBolt from "@material-symbols/svg-400/outlined/offline_bolt.svg?react";
import OpenInNew from "@material-symbols/svg-400/outlined/open_in_new.svg?react";
import Pause from "@material-symbols/svg-400/outlined/pause.svg?react";
import Pending from "@material-symbols/svg-400/outlined/pending.svg?react";
import Person from "@material-symbols/svg-400/outlined/person.svg?react";
import PersonOff from "@material-symbols/svg-400/outlined/person_off.svg?react";
import PersonPin from "@material-symbols/svg-400/outlined/person_pin.svg?react";
import PersonRemove from "@material-symbols/svg-400/outlined/person_remove.svg?react";
import PersonSearch from "@material-symbols/svg-400/outlined/person_search.svg?react";
import PhoneDisabled from "@material-symbols/svg-400/outlined/phone_disabled.svg?react";
import PhoneMissed from "@material-symbols/svg-400/outlined/phone_missed.svg?react";
import Photo from "@material-symbols/svg-400/outlined/photo.svg?react";
import PhotoCamera from "@material-symbols/svg-400/outlined/photo_camera.svg?react";
import PinDrop from "@material-symbols/svg-400/outlined/pin_drop.svg?react";
import ProgressActivity from "@material-symbols/svg-400/outlined/progress_activity.svg?react";
import Receipt from "@material-symbols/svg-400/outlined/receipt.svg?react";
import Refresh from "@material-symbols/svg-400/outlined/refresh.svg?react";
import ReleaseAlert from "@material-symbols/svg-400/outlined/release_alert.svg?react";
import Remove from "@material-symbols/svg-400/outlined/remove.svg?react";
import Repeat from "@material-symbols/svg-400/outlined/repeat.svg?react";
import RepeatOne from "@material-symbols/svg-400/outlined/repeat_one.svg?react";
import Replay from "@material-symbols/svg-400/outlined/replay.svg?react";
import RocketLaunch from "@material-symbols/svg-400/outlined/rocket_launch.svg?react";
import RotateRight from "@material-symbols/svg-400/outlined/rotate_right.svg?react";
import SavingsFill from "@material-symbols/svg-400/outlined/savings-fill.svg?react";
import Savings from "@material-symbols/svg-400/outlined/savings.svg?react";
import Schedule from "@material-symbols/svg-400/outlined/schedule.svg?react";
import School from "@material-symbols/svg-400/outlined/school.svg?react";
import Search from "@material-symbols/svg-400/outlined/search.svg?react";
import SentimentDissatisfied from "@material-symbols/svg-400/outlined/sentiment_dissatisfied.svg?react";
import SentimentNeutral from "@material-symbols/svg-400/outlined/sentiment_neutral.svg?react";
import SentimentSatisfied from "@material-symbols/svg-400/outlined/sentiment_satisfied.svg?react";
import Settings from "@material-symbols/svg-400/outlined/settings.svg?react";
import ShoppingBasket from "@material-symbols/svg-400/outlined/shopping_basket.svg?react";
import Smartphone from "@material-symbols/svg-400/outlined/smartphone.svg?react";
import Sms from "@material-symbols/svg-400/outlined/sms.svg?react";
import SpeakerNotes from "@material-symbols/svg-400/outlined/speaker_notes.svg?react";
import SpeakerNotesOff from "@material-symbols/svg-400/outlined/speaker_notes_off.svg?react";
import Stop from "@material-symbols/svg-400/outlined/stop.svg?react";
import Sunny from "@material-symbols/svg-400/outlined/sunny.svg?react";
import SupervisedUserCircle from "@material-symbols/svg-400/outlined/supervised_user_circle.svg?react";
import SupportAgent from "@material-symbols/svg-400/outlined/support_agent.svg?react";
import SwapVert from "@material-symbols/svg-400/outlined/swap_vert.svg?react";
import Sync from "@material-symbols/svg-400/outlined/sync.svg?react";
import Task from "@material-symbols/svg-400/outlined/task.svg?react";
import ThumbDown from "@material-symbols/svg-400/outlined/thumb_down.svg?react";
import ThumbUp from "@material-symbols/svg-400/outlined/thumb_up.svg?react";
import Train from "@material-symbols/svg-400/outlined/train.svg?react";
import TrendingDown from "@material-symbols/svg-400/outlined/trending_down.svg?react";
import TrendingUp from "@material-symbols/svg-400/outlined/trending_up.svg?react";
import Undo from "@material-symbols/svg-400/outlined/undo.svg?react";
import Update from "@material-symbols/svg-400/outlined/update.svg?react";
import Upload from "@material-symbols/svg-400/outlined/upload.svg?react";
import UploadFile from "@material-symbols/svg-400/outlined/upload_file.svg?react";
import Visibility from "@material-symbols/svg-400/outlined/visibility.svg?react";
import VisibilityOff from "@material-symbols/svg-400/outlined/visibility_off.svg?react";
import Voicemail from "@material-symbols/svg-400/outlined/voicemail.svg?react";
import VolunteerActivism from "@material-symbols/svg-400/outlined/volunteer_activism.svg?react";
import WandShine from "@material-symbols/svg-400/outlined/wand_shine.svg?react";
import Warning from "@material-symbols/svg-400/outlined/warning.svg?react";
import Work from "@material-symbols/svg-400/outlined/work.svg?react";
import AutoAwesome from "assets/icons/md-auto-awesome.svg?react";
import { em } from "polished";

// ⚠️ THIS IS AN EXCEPTION and should stay the only one (icon only exists in old md version) ⚠️

// ------------------ ⚠️ READ BEFORE ADDING OR EDITING ICONS ⚠️ ------------------
// 1. Icons are imported from @material-symbols/svg-400/outlined
// (it doesn't prevent filled versions to be used),
// even if you must fight, ensure this remains true at anytime
// 2. icon names are the same as the material design icons names.
// it allows devs and product to speak the same language
// 3. Outlined icons are considered as default ones meaning that filled icons versions
// must be imported using suffix "Fill" (ex: CheckFill)
// where should i found my icons :
// - https://fonts.google.com/icons (style: material symbols / outlined)
// ------------------ ⚠️ READ BEFORE ADDING OR EDITING ICONS ⚠️ ------------------

type SvgIconProps = {
  width: number | string;
  height: number | string;
  filled?: true;
  fill?: string;
};

export const IconsMapping = {
  formatBold: ({ ...p }) => <FormatBold {...p} />,
  formatItalic: ({ ...p }) => <FormatItalic {...p} />,
  formatStrikethrough: ({ ...p }) => <FormatStrikethrough {...p} />,
  formatUnderlined: ({ ...p }) => <FormatUnderlined {...p} />,
  formatListBulleted: ({ ...p }) => <FormatListBulleted {...p} />,
  formatListNumbered: ({ ...p }) => <FormatListNumbered {...p} />,
  checkList: ({ ...p }) => <Checklist {...p} />,
  progressActivity: ({ ...p }) => <ProgressActivity {...p} />,
  cancel: ({ ...p }) => <Cancel {...p} />,
  arrowForward: ({ ...p }) => <ArrowForward {...p} />,
  arrowBack: ({ ...p }) => <ArrowBack {...p} />,
  arrowDropUp: ({ ...p }) => <ArrowDropUp {...p} />,
  arrowDropDown: ({ ...p }) => <ArrowDropDown {...p} />,
  chevronRight: ({ ...p }) => <ChevronRight {...p} />,
  chevronLeft: ({ ...p }) => <ChevronLeft {...p} />,
  check: ({ ...p }) => <Check {...p} />,
  checkBox: ({ ...p }) => <CheckBox {...p} />,
  close: ({ ...p }) => <Close {...p} />,
  call: ({ ...p }) => <Call {...p} />,
  callMade: ({ ...p }) => <CallMade {...p} />,
  callReceived: ({ ...p }) => <CallReceived {...p} />,
  mail: ({ ...p }) => <Mail {...p} />,
  event: ({ ...p }) => <Event {...p} />,
  eventAvailable: ({ ...p }) => <EventAvailable {...p} />,
  calendarToday: ({ ...p }) => <CalendarToday {...p} />,
  article: ({ ...p }) => <Article {...p} />,
  arrowRightAlt: ({ ...p }) => <ArrowRightAlt {...p} />,
  arrowRight: ({ ...p }) => <ArrowRight {...p} />,
  repeat: ({ ...p }) => <Repeat {...p} />,
  repeatOne: ({ ...p }) => <RepeatOne {...p} />,
  backup: ({ ...p }) => <Backup {...p} />,
  fileCopy: ({ ...p }) => <FileCopy {...p} />,
  home: ({ ...p }) => <Home {...p} />,
  work: ({ ...p }) => <Work {...p} />,
  notifications: ({ ...p }) => <Notifications {...p} />,
  train: ({ ...p }) => <Train {...p} />,
  directionsCar: ({ ...p }) => <DirectionsCar {...p} />,
  trendingUp: ({ ...p }) => <TrendingUp {...p} />,
  trendingDown: ({ ...p }) => <TrendingDown {...p} />,
  refresh: ({ ...p }) => <Refresh {...p} />,
  moreHoriz: ({ ...p }) => <MoreHoriz {...p} />,
  link: ({ ...p }) => <Link {...p} />,
  search: ({ ...p }) => <Search {...p} />,
  edit: ({ ...p }) => <Edit {...p} />,
  add: ({ ...p }) => <Add {...p} />,
  locationOn: ({ ...p }) => <LocationOn {...p} />,
  pinDrop: ({ ...p }) => <PinDrop {...p} />,
  locationOff: ({ ...p }) => <LocationOff {...p} />,
  forum: ({ ...p }) => <Forum {...p} />,
  undo: ({ ...p }) => <Undo {...p} />,
  arrowLeft: ({ ...p }) => <ArrowLeft {...p} />,
  notificationsOff: ({ ...p }) => <NotificationsOff {...p} />,
  lockOpen: ({ ...p }) => <LockOpen {...p} />,
  delete: ({ ...p }) => <Delete {...p} />,
  error: ({ ...p }) => <Error {...p} />,
  draft: ({ ...p }) => <Draft {...p} />,
  remove: ({ ...p }) => <Remove {...p} />,
  directionsWalk: ({ ...p }) => <DirectionsWalk {...p} />,
  schedule: ({ ...p }) => <Schedule {...p} />,
  moreTime: ({ ...p }) => <MoreTime {...p} />,
  sunny: ({ ...p }) => <Sunny {...p} />,
  bedtime: ({ ...p }) => <Bedtime {...p} />,
  wandShine: ({ ...p }) => <WandShine {...p} />,
  download: ({ ...p }) => <Download {...p} />,
  info: ({ ...p }) => <Info {...p} />,
  person: ({ ...p }) => <Person {...p} />,
  group: ({ ...p }) => <Group {...p} />,
  photo: ({ ...p }) => <Photo {...p} />,
  photoCamera: ({ ...p }) => <PhotoCamera {...p} />,
  barChart: ({ ...p }) => <BarChart {...p} />,
  openInNew: ({ ...p }) => <OpenInNew {...p} />,
  warning: ({ ...p }) => <Warning {...p} />,
  visibility: ({ ...p }) => <Visibility {...p} />,
  euro: ({ ...p }) => <Euro {...p} />,
  checkCircle: ({ filled, ...p }) => (filled ? <CheckCircleFill {...p} /> : <CheckCircle {...p} />),
  block: ({ ...p }) => <Block {...p} />,
  personOff: ({ ...p }) => <PersonOff {...p} />,
  personPin: ({ ...p }) => <PersonPin {...p} />,
  persoSearch: ({ ...p }) => <PersonSearch {...p} />,
  archive: ({ ...p }) => <Archive {...p} />,
  celebration: ({ ...p }) => <Celebration {...p} />,
  receipt: ({ ...p }) => <Receipt {...p} />,
  notListedLocation: ({ ...p }) => <NotListedLocation {...p} />,
  accountCircle: ({ ...p }) => <AccountCircle {...p} />,
  personRemove: ({ ...p }) => <PersonRemove {...p} />,
  phoneDisabled: ({ ...p }) => <PhoneDisabled {...p} />,
  swapVert: ({ ...p }) => <SwapVert {...p} />,
  forest: ({ ...p }) => <Forest {...p} />,
  addComment: ({ ...p }) => <AddComment {...p} />,
  shoppingBasket: ({ ...p }) => <ShoppingBasket {...p} />,
  homeWork: ({ ...p }) => <HomeWork {...p} />,
  favorite: ({ filled, ...p }) => (filled ? <FavoriteFill {...p} /> : <Favorite {...p} />),
  contentCopy: ({ ...p }) => <ContentCopy {...p} />,
  contract: ({ ...p }) => <Contract {...p} />,
  savings: ({ filled, ...p }) => (filled ? <SavingsFill {...p} /> : <Savings {...p} />),
  volunteerActivism: ({ ...p }) => <VolunteerActivism {...p} />,
  task: ({ ...p }) => <Task {...p} />,
  documentScanner: ({ ...p }) => <DocumentScanner {...p} />,
  noPhotography: ({ ...p }) => <NoPhotography {...p} />,
  visibilityOff: ({ ...p }) => <VisibilityOff {...p} />,
  findReplace: ({ ...p }) => <FindReplace {...p} />,
  factCheck: ({ ...p }) => <FactCheck {...p} />,
  followTheSigns: ({ ...p }) => <FollowTheSigns {...p} />,
  supportAgent: ({ ...p }) => <SupportAgent {...p} />,
  monitorHeart: ({ ...p }) => <MonitorHeart {...p} />,
  offlineBolt: ({ ...p }) => <OfflineBolt {...p} />,
  bolt: ({ ...p }) => <Bolt {...p} />,
  backHand: ({ ...p }) => <BackHand {...p} />,
  news: ({ ...p }) => <News {...p} />,
  contentPasteSearch: ({ ...p }) => <ContentPasteSearch {...p} />,
  folderOpen: ({ ...p }) => <FolderOpen {...p} />,
  folder: ({ ...p }) => <Folder {...p} />,
  settings: ({ ...p }) => <Settings {...p} />,
  medicalInformation: ({ ...p }) => <MedicalInformation {...p} />,
  contentPaste: ({ ...p }) => <ContentPaste {...p} />,
  school: ({ ...p }) => <School {...p} />,
  folderShared: ({ ...p }) => <FolderShared {...p} />,
  listAlt: ({ ...p }) => <ListAlt {...p} />,
  pending: ({ ...p }) => <Pending {...p} />,
  callMissed: ({ ...p }) => <CallMissed {...p} />,
  callMissedOutgoing: ({ ...p }) => <CallMissedOutgoing {...p} />,
  eventBusy: ({ ...p }) => <EventBusy {...p} />,
  releaseAlert: ({ ...p }) => <ReleaseAlert {...p} />,
  phoneMissed: ({ ...p }) => <PhoneMissed {...p} />,
  voicemail: ({ ...p }) => <Voicemail {...p} />,
  rotateRight: ({ ...p }) => <RotateRight {...p} />,
  draw: ({ ...p }) => <Draw {...p} />,
  markChatUnread: ({ ...p }) => <MarkChatUnread {...p} />,
  speakerNotesOff: ({ ...p }) => <SpeakerNotesOff {...p} />,
  speakerNotes: ({ ...p }) => <SpeakerNotes {...p} />,
  chat: ({ ...p }) => <Chat {...p} />,
  handshake: ({ ...p }) => <Handshake {...p} />,
  dangerous: ({ ...p }) => <Dangerous {...p} />,
  elderly: ({ ...p }) => <Elderly {...p} />,
  upload: ({ ...p }) => <Upload {...p} />,
  uploadFile: ({ ...p }) => <UploadFile {...p} />,
  smartphone: ({ ...p }) => <Smartphone {...p} />,
  sentimentSatisfied: ({ ...p }) => <SentimentSatisfied {...p} />,
  sentimentDissatisfied: ({ ...p }) => <SentimentDissatisfied {...p} />,
  sentimentNeutral: ({ ...p }) => <SentimentNeutral {...p} />,
  thumbUp: ({ ...p }) => <ThumbUp {...p} />,
  thumbDown: ({ ...p }) => <ThumbDown {...p} />,
  assignment: ({ ...p }) => <Assignment {...p} />,
  replay: ({ ...p }) => <Replay {...p} />,
  cake: ({ ...p }) => <Cake {...p} />,
  cottage: ({ ...p }) => <Cottage {...p} />,
  diversity1: ({ ...p }) => <Diversity1 {...p} />,
  filterAlt: ({ ...p }) => <FilterAlt {...p} />,
  autoAwesome: ({ ...p }) => <AutoAwesome {...p} />,
  supervisedUserCircle: ({ ...p }) => <SupervisedUserCircle {...p} />,
  howToReg: ({ ...p }) => <HowToReg {...p} />,
  cached: ({ ...p }) => <Cached {...p} />,
  sms: ({ ...p }) => <Sms {...p} />,
  description: ({ ...p }) => <Description {...p} />,
  rocketLaunch: ({ ...p }) => <RocketLaunch {...p} />,
  sync: ({ ...p }) => <Sync {...p} />,
  mic: ({ ...p }) => <Mic {...p} />,
  map: ({ ...p }) => <Map {...p} />,
  pause: ({ ...p }) => <Pause {...p} />,
  stop: ({ ...p }) => <Stop {...p} />,
  keyboard: ({ ...p }) => <Keyboard {...p} />,
  update: ({ ...p }) => <Update {...p} />,
  contactSupportOutlined: ({ ...p }) => <ContactSupportOutlined {...p} />,
  articlePerson: ({ ...p }) => <ArticlePerson {...p} />,
  blurOn: ({ ...p }) => <BlurOn {...p} />,
  arrowUpward: ({ ...p }) => <ArrowUpward {...p} />,
  arrowDownward: ({ ...p }) => <ArrowDownward {...p} />,
  comment: ({ ...p }) => <Comment {...p} />,
} satisfies Record<string, (props: SvgIconProps) => JSX.Element>;

export type IconName = keyof typeof IconsMapping;

export type IconProps = {
  name: IconName;
  size?: number | string;
  color?: string;
  filled?: boolean;
};

export const Icon = ({ name, size = em(16), color = "currentColor", filled }: IconProps) => {
  const Icon = IconsMapping[name];

  return <Icon width={size} height={size} fill={color} filled={filled ? true : undefined} />;
};
